import Loading from 'component/Loading'
import { useEffect, useState } from 'react'

import API, { ResourceNotFoundError } from 'service/api'

const ImageMessage = ({
  message
}) =>
{
  const [media, setMedia] = useState(message.media)
  const [enlarge, setEnlarge] = useState(false)
  const [orientation, setOrientation] = useState('horizontal')

  const toggleImage = () =>
  {
    setEnlarge(!enlarge)
  }

  useEffect(() =>
  {
    // update refresh target to the latest component
    message.setMedia = setMedia

    // call only if API is not yet fetched
    if (!message.initialized && !message.media)
    {
      // increment retry count
      message.initialized = true

      // fetch image
      API.getMessageMedia(message.wa_id, message.seq).then(async resp => {
        const objUrl = URL.createObjectURL(await resp.blob())
        message.media = objUrl

        // delay re-rendering if it is not ready
        if (!message.setMedia)
        {
          setTimeout(() => message.setMedia(objUrl), 1000)
        }
        else
        {
          message.setMedia(objUrl)
        }
        delete message.setMedia
      }).catch(error => {
        if (error instanceof ResourceNotFoundError)
        {
          setMedia('error')
          return
        }
        throw error
      })
    }
  }, [])

  useEffect(() =>
  {
    if (media) {
      let image = new Image()
      image.src = media
      image.onload = () => {
        setOrientation(image.naturalWidth > image.naturalHeight
          ? 'horizontal'
          : 'vertical')
      }
    }
  }, [media])

  return !media
    ? <div className="image-message loading"><Loading /></div>
    : 'error' == media
    ? <div className="image-message-error">無法載入圖片。</div>
    : (
      <div className={`image-message ${enlarge?'modal':''}`}>
        <img className={orientation}
            src={media} onClick={toggleImage} />
      </div>
    )
}

export default ImageMessage
